'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _EntypoIcon = require('../EntypoIcon');

var _EntypoIcon2 = _interopRequireDefault(_EntypoIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var iconClass = 'entypo-svgicon entypo--Colours';

var EntypoColours = function EntypoColours(props) {
    return _react2.default.createElement(
        _EntypoIcon2.default,
        _extends({ propClass: iconClass }, props),
        _react2.default.createElement('path', { d: 'M3.179,5.998C2.756,5.648,2.122,5.708,1.771,6.13L0.494,7.669c-0.35,0.423-0.291,1.058,0.131,1.407l7.888,6.542L4.706,7.264L3.179,5.998z M7.013,2.683l-1.82,0.829C4.694,3.74,4.471,4.337,4.698,4.836l4.25,9.325l0.213-9.179L8.339,3.178C8.109,2.678,7.513,2.455,7.013,2.683z M14.211,2.887c0.013-0.55-0.427-1.01-0.976-1.023l-2-0.046c-0.549-0.013-1.009,0.427-1.022,0.976L9.974,13.037l4.19-8.167L14.211,2.887z M19.191,3.837l-1.779-0.913c-0.489-0.25-1.096-0.055-1.347,0.434L9.674,15.814c-0.251,0.489-0.056,1.096,0.434,1.347l1.779,0.913c0.489,0.251,1.095,0.056,1.346-0.433l6.391-12.456C19.875,4.694,19.68,4.088,19.191,3.837z M12.799,16.293c-0.252,0.492-0.855,0.686-1.346,0.434c-0.492-0.252-0.685-0.854-0.433-1.346c0.252-0.492,0.854-0.685,1.346-0.433C12.858,15.199,13.051,15.802,12.799,16.293z' })
    );
};

exports.default = EntypoColours;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-entypo/lib/entypo/Colours.js
// module id = ./node_modules/react-entypo/lib/entypo/Colours.js
// module chunks = 2